<template>
<div>
    <Header />
    <div class="desktop">
        <BlackHeaderCenter :headerText="headerText" :subText="subText" :fadedText="fadedText" />
    </div>
    <div class="mobile">
        <BlackHeaderMobile :headerText="headerText" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <BodyLinks />
    <b-container class=" mt-4">
        <Activation />
        <b-row class="desktop">
            <b-col cols="3">
                <InterpreterSidebar class="mt-5" created='active' />
            </b-col>
            <b-col cols="9">
                <b-row class="head-box">
                    <b-col cols="4" class="">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon font-scale="0.99" icon="tag"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="text" placeholder="from language"></b-form-input>
                        </b-input-group>
                    </b-col>
                    <b-col cols="4" class="">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon font-scale="0.99" icon="tag"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="text" placeholder="to language "></b-form-input>
                        </b-input-group>
                    </b-col>
                    <b-col cols="4" class="btn-box">
                        <button class="btn btn-warning btn-culture">
                            <b-icon font-scale="0.99" icon="search"></b-icon>Search
                        </button>
                    </b-col>
                </b-row>
                <p class="mt-4 d-flex justify-content-between" v-if="!loading">
                    <span>
                        Per page:
                        <select class="" v-model="no_per_page" @change="allInterpreters(page)">
                            <option value="10" selected>10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select> items
                    </span>
                    <span>{{ page }} of {{ rows }} Interpreters</span>
                </p>
                <div class="mt-4" v-if="loading">
                    <content-loader :speed="2" :height="400" :width="600">
                        <circle cx="25" cy="112" r="15" />
                        <rect x="10" y="18" rx="0" ry="0" width="464" height="9" />
                        <rect x="497" y="10" rx="0" ry="0" width="144" height="144" />
                        <rect x="10" y="41" rx="0" ry="0" width="464" height="9" />
                        <rect x="10" y="65" rx="0" ry="0" width="364" height="9" />
                        <rect x="50" y="98" rx="0" ry="0" width="115" height="9" />
                        <rect x="50" y="115" rx="0" ry="0" width="115" height="10" />
                    </content-loader>
                </div>
                <div class="mt-3" v-if="interpreters.length > 0">
                    <div v-for="(interpreter, index) in interpreters" :key="index">
                        <InterpreterCard @handleDelete="deleteInterpreter(interpreter)" :fromLanguage="interpreter.from_language" :toLanguage="interpreter.to_language" :routeId="interpreter.interpreter_id" torouteName="update-interpreter" detailsRoute="interpreter-details" showBookBtn="true" :fromExperience="interpreter.from_lang_experience" :toExperience="interpreter.to_lang_experience" showProfileBtn="true" @handleProfile="viewProfile(interpreter.host)" class="mb-4" :hostImg="interpreter.photo" :reason="interpreter.reason" :hireStatus="interpreter.hire_status" :hostName="hostName(interpreter)" :starRating="interpreter.average_ratings" />
                    </div>
                </div>
                <div class="mt-4" v-if="interpreters.length == 0 && !loading">
                    No interpreter profile created yet
                </div>
                <b-pagination v-model="page" :total-rows="rows" @change="allInterpreters" :per-page="no_per_page">
                </b-pagination>

            </b-col>
        </b-row>
        <div class="mobile">
            <b-row>
                <b-col cols="3">
                    <InterpreterSidebar menuId="slidmenu" @handleOpen="openMenu" @handleHide="hideSidemenu" class="mt-5" created='active' />
                </b-col>
                <b-col cols="9">
                    <b-row class="head-box">
                        <b-col cols="12" class="">
                            <b-input-group class="">
                                <b-input-group-prepend is-text>
                                    <b-icon font-scale="0.99" icon="calendar2-date"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input type="text" placeholder="Listing Name "></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col cols="12" class="">
                            <b-input-group class="">
                                <b-input-group-prepend is-text>
                                    <b-icon font-scale="0.99" icon="globe"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input type="text" placeholder="Location "></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col cols="12" class="btn-box">
                            <button class="btn btn-warning btn-culture">
                                Search
                            </button>
                        </b-col>
                    </b-row>
                </b-col>

            </b-row>
            <p class="mb-4 mt-4">{{ interpreters.length }} results</p>
            <div class="mt-4" v-if="loading">
                <content-loader :speed="2" :height="400" :width="600">
                    <circle cx="25" cy="112" r="15" />
                    <rect x="10" y="18" rx="0" ry="0" width="464" height="9" />
                    <rect x="497" y="10" rx="0" ry="0" width="144" height="144" />
                    <rect x="10" y="41" rx="0" ry="0" width="464" height="9" />
                    <rect x="10" y="65" rx="0" ry="0" width="364" height="9" />
                    <rect x="50" y="98" rx="0" ry="0" width="115" height="9" />
                    <rect x="50" y="115" rx="0" ry="0" width="115" height="10" />
                </content-loader>
            </div>
            <div class="mt-5" v-if="interpreters.length > 0">
                <div v-for="(interpreter, index) in interpreters" :key="index">
                    <InterpreterCard :fromLanguage="interpreter.from_language" :toLanguage="interpreter.to_language" torouteName="update-interpreter" detailsRoute="interpreter-details" showBookBtn="true" :fromExperience="interpreter.from_lang_experience" :toExperience="interpreter.to_lang_experience" showProfileBtn="true" @handleProfile="viewProfile(interpreter.host)" class="mb-4" :hostImg="interpreter.photo" :reason="interpreter.reason" :hireStatus="interpreter.hire_status" :hostName="hostName(interpreter)" :starRating="interpreter.average_ratings" />
                </div>
                <div class="mt-4" v-if="interpreters.length == 0 && !loading">
                    No language interpreter created yet
                </div>
                <b-pagination v-model="page" :total-rows="rows" @change="allInterpreters" :per-page="no_per_page">
                </b-pagination>

            </div>
        </div>
    </b-container>
    <Footer />
</div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import InterpreterSidebar from "@/components/InterpretersSidebar.vue"
import Footer from "@/components/Footer.vue";
import BlackHeaderCenter from "@/components/BlackHeaderCenter.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import InterpreterCard from "@/components/ManageInterpreterCard.vue";
import Activation from "@/components/Activation.vue";
import {
    ContentLoader
} from "vue-content-loader";

import axios from "axios";
import {
    getBaseUrl
} from "../../../../utils/common";
const base_url = getBaseUrl();
export default {
    name: 'created-language-interpreters',
    components: {
        Header,
        BodyLinks,
        BlackHeaderCenter,
        InterpreterSidebar,
        BlackHeaderMobile,
        Activation,
        InterpreterCard,
        ContentLoader,
        Footer
    },
    data: function () {
        return {
            headerText: "Created Interpreters Profiles",
            subText: "Manage your interpreter profiles",
            fadedText: "Hosts",
            loading: true,
            asyncLoading: false,
            cancelLoading: false,
            listingTypeSelected: null,
            interpreters: [],
            interpreter: {
                status: ''
            },
            no_per_page: 10,
            page: 1,
            pagination: {},
            cancelState: 'Cancel'

        }
    },
    computed: {
        currentUser: function () {
            return this.$store.getters.currentUser;
        },
        rows() {
            return this.pagination.total
        },
    },
    mounted() {
        this.allInterpreters();
    },
    methods: {
        hostName(interpreter) {
            return interpreter.host.first_name + ' ' + interpreter.host.last_name;
        },
        openMenu() {
            this.$root.$refs.A.openMenu('slidmenu')
        },
        hideSidemenu() {
            this.$root.$refs.A.hideSidemenu('slidmenu')
        },
        location(interpreter) {
            return interpreter.attendance_mode == 'physical' ? 'In person' : 'Online'
        },
        async deleteInterpreter(interpreter) {
            if (confirm("Do you really want to delete this interpreter profile?")) {
                try {
                    await axios({
                        url: `${base_url}/api/v2/language/interpreters/${interpreter.interpreter_id}`,
                        method: "DELETE",
                    })
                    this.allInterpreters();
                } catch (error) {
                    this.$root.$refs.A.makeToast('danger', error.response.data.message)
                }
            }
        },
        async allInterpreters(page = 1) {
            const hostid = this.currentUser.user_id
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/language/interpreters`,
                    params: {
                        host_id: hostid,
                        page: page,
                        no_per_page: this.no_per_page,
                    },
                    method: "GET",
                })
                this.loading = false;
                this.interpreters = resp.data.data;
                this.pagination = resp.data.meta
            } catch (error) {
                this.loading = false;
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
    }

}
</script>

<style scoped>
.custom-select {
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
    border-radius: 8px;
    padding: 20px 16px;
    border: none;
    height: 59px;
    width: 95%;
}

.btn-culture {
    padding: 10px 60px !important;
}

.form-control {
    border-radius: 0 8px 8px 0 !important;
    height: calc(2em + 0.75rem + 8px) !important;

}

.form-control:focus {
    outline: none !important;
    box-shadow: none !important;
}

.custom-select:focus {
    outline: none !important;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
}

.bi-search {
    margin-right: 1rem;
}

.custom-select .caret {
    padding-right: 10px;
}

.custom-control {
    margin: 20px auto
}

.btn-box {
    margin: 14px 0
}

.head-box {
    margin: 35px auto auto;
    box-shadow: 0px 4px 20px rgb(0 0 0 / 10%);
    border-radius: 5px;
    padding: 10px;
    background-color: #F6F7F7;
}

.inner-header-box {
    padding: 20px;
    border-radius: 4px;
    cursor: pointer;
}

.inner-header-box:hover {
    background: #000;
    color: #fff;
    border-radius: 4px;
    transition: ease-in 0.3s;

}

.inner-header-box:hover .b-icon.bi {
    color: rgba(247, 177, 49, 1)
}

.list-group {
    padding: 16px 16px 16px 16px;
    background: #FFFFFF;
    box-shadow: 2px 6px 19px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
}

.list-group-item {
    padding: 0.7rem 1rem !important;
    text-align: left;
    border: none !important;
    margin: 10px 0 !important;
}

.list-group-item.active {
    background: rgba(86, 92, 99, 0.05) !important;
    color: rgba(86, 92, 99, 1) !important;
    text-align: center !important
}
</style>
